var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargerPinPublic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 39,
    viewBox: "0 0 28 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5691_18717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0832 29.1898C19.1741 29.1898 24.1117 24.2522 24.1117 18.1613C24.1117 12.0704 19.1741 7.13281 13.0832 7.13281C6.99232 7.13281 2.05469 12.0704 2.05469 18.1613C2.05469 24.2522 6.99232 29.1898 13.0832 29.1898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1479 6.5C10.058 6.50177 7.09538 7.73043 4.91118 9.91589C2.72697 12.1013 1.5 15.0647 1.5 18.1545C1.5 24.5878 13.1479 38.5 13.1479 38.5C13.1479 38.5 24.8091 24.5878 24.8091 18.1545C24.8091 16.6235 24.5074 15.1074 23.9213 13.693C23.3352 12.2786 22.4761 10.9935 21.3932 9.91118C20.3102 8.82887 19.0247 7.97054 17.6099 7.38524C16.1951 6.79993 14.6789 6.49913 13.1479 6.5ZM13.1479 27.9244C11.2137 27.9257 9.32259 27.3532 7.71384 26.2795C6.10508 25.2057 4.85098 23.6789 4.11019 21.8922C3.36941 20.1056 3.17524 18.1393 3.55225 16.2422C3.92927 14.3451 4.86053 12.6025 6.22819 11.2349C7.59586 9.86719 9.33847 8.93593 11.2355 8.55892C13.1326 8.1819 15.0989 8.37607 16.8856 9.11685C18.6723 9.85764 20.1991 11.1117 21.2728 12.7205C22.3466 14.3293 22.919 16.2204 22.9177 18.1545C22.9177 19.4375 22.665 20.7079 22.174 21.8933C21.683 23.0786 20.9634 24.1556 20.0562 25.0628C19.149 25.9701 18.0719 26.6897 16.8866 27.1807C15.7013 27.6716 14.4309 27.9244 13.1479 27.9244Z",
    fill: "#0073CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12L14.8471 16.1459H19.2063L15.6796 18.7082L17.0267 22.8541L13.5 20.2918L9.97329 22.8541L11.3204 18.7082L7.79366 16.1459H12.1529L13.5 12Z",
    fill: "#0073CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5691_18717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 38,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerPinPublic);
export default __webpack_public_path__ + "static/media/charger-pin-public.83357a331e9845143941f1adb1cf27fb.svg";
export { ForwardRef as ReactComponent };